import forEach from "lodash/forEach";
import { Node as ProseMirrorNode } from "prosemirror-model";
import { TextSelection } from "prosemirror-state";
import { findParentNodeOfTypeClosestToPos } from "prosemirror-utils";
import { getTarget } from "../helpers";
export function makeSuggesterCallbacks(options) {
    const keyBindings = {};
    forEach(options.keymap, (handler, key) => {
        keyBindings[key] = (params) => handler({ ...params, onSelect: params.command });
    });
    return {
        keyBindings,
        onChange: (params) => {
            const { view, range, queryText, command } = params;
            const { from } = range;
            // Ensure the `from` position is valid
            const maxPos = view.state.doc.content.size;
            if (!canStartSuggester(view, from) || from < 0 || from > maxPos) {
                return;
            }
            return options.onChange({
                ...params,
                position: view.coordsAtPos(from),
                targetElement: getTarget(view, from),
                query: queryText.partial,
                onSelect: command,
            });
        },
        onExit: () => options.onExit(),
    };
}
export function insertSuggestNodeCommand(nodeJSON, cursorOffset) {
    return (match, view) => {
        const tr = view.state.tr;
        const { from, to } = match.range;
        const node = ProseMirrorNode.fromJSON(view.state.schema, nodeJSON);
        tr.replaceRangeWith(from, to, node);
        tr.setSelection(TextSelection.near(tr.doc.resolve(from + cursorOffset)));
        view.dispatch(tr);
    };
}
export function insertSuggestionChar(state, tr, char) {
    var _a;
    const { $anchor, $head } = state.selection;
    // If there's anything before the insertion point, makes sure there's at least one space separating
    if ($anchor.nodeBefore && !((_a = $anchor.nodeBefore.text) === null || _a === void 0 ? void 0 : _a.endsWith(" "))) {
        tr.insertText(" ");
    }
    tr.insertText(char);
    // If there's anything after the insertion point, makes sure there's at least one space separating
    if ($head.nodeAfter && !$head.nodeAfter.text.startsWith(" ")) {
        tr.insertText(" ");
        tr.setSelection(TextSelection.near(tr.doc.resolve(tr.selection.from - 1)));
    }
    tr.scrollIntoView();
    return tr;
}
export function canStartSuggester(view, from) {
    const { schema } = view.state;
    if (findParentNodeOfTypeClosestToPos(view.state.doc.resolve(from), schema.nodes.code_block)) {
        // do not start suggester when inside code block
        return false;
    }
    return true;
}
